// Switch on/off — style-nya sama persis dengan Toggle yang dipakai di
// admin/Layanan (LayananForm.jsx), dipindah ke sini biar bisa dipakai ulang
// di tempat lain (contoh: dark mode switch di navbar mobile).
export default function Toggle({ checked, onChange, size = 'md', ...rest }) {
  const dims = size === 'sm'
    ? { track: 'w-9 h-5', knob: 'w-4 h-4', translate: '1rem' }
    : { track: 'w-11 h-6', knob: 'w-5 h-5', translate: '1.25rem' };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative ${dims.track} rounded-full flex-shrink-0 transition-colors duration-300 ease-out hover:opacity-90 active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-neutral-900 focus-visible:ring-forest-500/50 ${checked ? '' : 'bg-neutral-300 dark:bg-neutral-700'}`}
      style={{ transition: 'background-color 300ms, transform 150ms var(--ease-spring)', background: checked ? 'var(--accent, #4A7A3A)' : undefined }}
      {...rest}
    >
      <span
        className={`absolute top-0.5 left-0.5 ${dims.knob} rounded-full bg-white shadow-md`}
        style={{ transform: checked ? `translateX(${dims.translate})` : 'translateX(0)', transition: 'transform 300ms var(--ease-spring)' }}
      />
    </button>
  );
}